import { render } from "./fixedTab.vue?vue&type=template&id=12bf0c91&scoped=true"
import script from "./fixedTab.vue?vue&type=script&lang=js"
export * from "./fixedTab.vue?vue&type=script&lang=js"

import "./fixedTab.vue?vue&type=style&index=0&id=12bf0c91&lang=scss"
import "./fixedTab.vue?vue&type=style&index=1&id=12bf0c91&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bf0c91"]])

export default __exports__